import React from 'react';
import './destacadoMuestra.scss';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from "@contentful/rich-text-types"

const optionsMuestra = {
  renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <div className="f-muestra" dangerouslySetInnerHTML={{__html:children}} />
  }
}

const DestacadoMuestra = (props) => {
    const { content } = props;
    return(
        <div className="f-destacado-muestra">
            {content && content.elementosHtml && documentToReactComponents(content.elementosHtml.json, optionsMuestra)}
        </div> 
    )
}

export default DestacadoMuestra;